import { memo } from "react"
import { Box, Typography } from "@mui/material"
import { styles } from "./InfoCard.styles"

const VARIANT_STYLES = {
  default: {
    card: styles.card,
    iconWrapper: styles.iconWrapper,
    iconImg: styles.iconImg,
    titleStyle: styles.title,
    textStyle: styles.subtitle,
  },
  white: {
    card: styles.whiteCard,
    iconWrapper: styles.iconWrapper,
    iconImg: styles.iconImg,
    titleStyle: styles.title,
    textStyle: styles.subtitle,
  },
  info: {
    card: styles.infoCard,
    iconWrapper: styles.infoIconWrapper,
    iconImg: styles.infoIconImg,
    titleStyle: styles.infoText,
    textStyle: styles.infoText,
  },
  tip: {
    card: styles.tipCard,
    iconWrapper: styles.tipIconWrapper,
    iconImg: styles.iconImg,
    titleStyle: styles.tipTitle,
    textStyle: styles.tipText,
  },
  insight: {
    card: styles.insightCard,
    iconWrapper: styles.insightIconWrapper,
    iconImg: styles.iconImg,
    titleStyle: styles.insightTitle,
    textStyle: styles.insightText,
  },
  success: {
    card: styles.successCard,
    iconWrapper: styles.successIconWrapper,
    iconImg: styles.iconImg,
    titleStyle: styles.successTitle,
    textStyle: styles.successText,
  },
  tipBlue: {
    card: styles.tipBlueCard,
    iconWrapper: styles.tipBlueIconWrapper,
    iconImg: styles.iconImg,
    titleStyle: styles.tipBlueTitle,
    textStyle: styles.tipBlueText,
  },
}

export const InfoCard = memo(
  ({
    icon,
    title,
    subtitle,
    description,
    linkText,
    onLinkClick,
    action,
    variant = "default",
    layout = "row",
    textAlign = "center",
    sx = {},
  }) => {
    const variantStyles = VARIANT_STYLES[variant] || VARIANT_STYLES.default

    const { card, iconWrapper, iconImg, titleStyle, textStyle } = variantStyles

    const isColumn = layout === "column"

    const renderIcon = () => {
      if (!icon) return null
      if (typeof icon === "string") {
        return <Box component="img" src={icon} alt="Icon" sx={iconImg} />
      }
      const IconComponent = icon
      return <IconComponent sx={iconWrapper} />
    }

    return (
      <Box
        sx={[
          card,
          isColumn && styles.columnCard,
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Box sx={iconWrapper}>{renderIcon()}</Box>

        <Box sx={[styles.textGroup, { textAlign }]}>
          {title && (
            <Typography variant="body2Bold" sx={titleStyle}>
              {title}
            </Typography>
          )}
          {(subtitle || description) && (
            <Typography variant="body2" sx={textStyle}>
              {subtitle || description}
            </Typography>
          )}
          {linkText && (
            <Typography variant="body2" sx={styles.link} onClick={onLinkClick}>
              {linkText}
            </Typography>
          )}
        </Box>

        {action && <Box>{action}</Box>}
      </Box>
    )
  }
)

export default InfoCard
